import { useState } from "react";
import { X } from "lucide-react";
import { useAds } from "./useAds";

export default function AdsTopBanner() {
  const { ads } = useAds("top_banner");
  const [closed, setClosed] = useState({});

  // Display only first 1 (already top banner = vedette). Multiple banners stack.
  const visible = ads.filter((a) => !closed[a.id]);
  if (visible.length === 0) return null;

  return (
    <div className="w-full" data-testid="ads-top-banner-wrapper">
      {visible.map((a) => (
        <div
          key={a.id}
          data-testid={`ads-top-banner-${a.id}`}
          className="w-full px-4 py-2.5 flex items-center justify-center gap-3 text-sm relative"
          style={{
            backgroundColor: a.bg_color || "#1a2332",
            color: a.text_color || "#FFFFFF",
          }}
        >
          <div className="flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-3 text-center sm:text-left">
            {a.title && <span className="font-headings font-bold">{a.title}</span>}
            {a.subtitle && <span className="opacity-90">{a.subtitle}</span>}
            {a.cta_label && a.cta_url && (
              <a
                href={a.cta_url}
                className="underline underline-offset-2 font-headings font-bold hover:opacity-90"
                data-testid={`ads-top-banner-cta-${a.id}`}
              >
                {a.cta_label} →
              </a>
            )}
          </div>
          <button
            onClick={() => setClosed((c) => ({ ...c, [a.id]: true }))}
            aria-label="Fermer"
            data-testid={`ads-top-banner-close-${a.id}`}
            className="absolute right-3 top-1/2 -translate-y-1/2 opacity-60 hover:opacity-100"
            style={{ color: a.text_color || "#FFFFFF" }}
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      ))}
    </div>
  );
}
